<mat-spinner></mat-spinner>
<h1>{{ data | translate }}</h1>
